import Cards from 'components/activity/cards/main/containers/CardsContainer';
import PinOptions from 'components/activity/cards/pinOptions/containers/PinOptionsContainer';

const cardsRoutes = [
    { path: '', element: <Cards />, pageTitle: 'Cards' },
    { path: 'pin-options', element: <PinOptions />, pageTitle: 'Pin Options' },
];

export default cardsRoutes;
